
module library {
  'use strict';

  export class LibrarySortCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$timeout',
      '$filter',
      '$window',
      'libraryService', 
      'anchorNavService',
      'pageMetaService',
      '$mdDialog',
      '$mdPanel',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope : ILibrarySortCtrlScope,
      private $timeout : ng.ITimeoutService,
      private $filter : library.IUniqueFilter,
      private $window : ng.IWindowService,
      private libraryService : ILibraryService,
      private anchorNavService : navigation.IAnchorNavService,
      private pageMetaService : navigation.IPageMetaService,
      private $mdDialog : ng.material.IDialogService,
      private $mdPanel : ng.material.IPanelService
      ) { 
      
      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

    }
    
    locals: { selectedType: DocumentType };

    
    public $onInit(): void {      
      this.$scope.data = this.locals.selectedType.Documents;
      this.$scope.getRevision = this.libraryService.getDefaultRevision;
    }

    itemDraggedAndDropped(srcList, srcIndex, targetList, targetIndex) {
      var d = this.$scope.data.splice(srcIndex, 1);   //remove at src index
      this.$scope.data.splice(targetIndex, 0, d[0]);  //insert at target index
      return true;
    }

    swapItems(index1, index2) {
      var temp = this.$scope.data[index1];
      this.$scope.data[index1] = this.$scope.data[index2];
      this.$scope.data[index2] = temp;
    }

    moveItemUp(index) {
      this.swapItems(index, index - 1);
    }

    moveItemDown(index) {
      this.swapItems(index, index + 1);
    }

    moveItemToTop(index) {
      var d = this.$scope.data.splice(index, 1);
      this.$scope.data.unshift(d[0]);
    }

    closeDialog() {
      this.$mdDialog.hide();
    }

    gotoTop() {
      $(".md-dialog-content").animate({
        scrollTop: 0
      }, 500);
    }


    save() {
      var renumTo = 0;
      var documentsToSave : number[] = [];

      for (var i = 0; i < (this.$scope.data.length - 1); i++) {
        var revN = this.$scope.getRevision(this.$scope.data[i]);
        var revNplus1 = this.$scope.getRevision(this.$scope.data[i + 1]);
        if (revN.ReleaseDate < revNplus1.ReleaseDate) {
          renumTo = i + 1;
        }
        if (revN.ReleaseDate.getTime() == revNplus1.ReleaseDate.getTime() && revN.DocumentFileSrcRevID < revNplus1.DocumentFileSrcRevID) {
          renumTo = i + 1;
        }
        documentsToSave.push(this.$scope.data[i].DocumentID);
      };

      this.$scope.showSaveInProgress = true;
      
      this.libraryService.saveDocumentSortOrder(pglob.RouteData.RouteEntry, renumTo, documentsToSave, this.locals.selectedType)
        .then((response) => {
          this.$scope.showSaveSuccess = true;
        })
        .catch((response) => {
          this.$scope.showSaveError = true;
        })
        .finally(() => {
          this.$scope.showSaveInProgress = false;
          this.$timeout(() => {
            this.$scope.showSaveSuccess = false;
            this.$scope.showSaveError = false;
          }, 3000);
        });

    }
  }
}